//Common service for dealing with small tables

app.factory(
    'ChangeLogService', ['LocalStorage', 'ApiService', '$rootScope', ChangeLogService]
);

function ChangeLogService(LocalStorage, ApiService, $rootScope) {
    self.GetChangeLogById = GetChangeLogById;
    self.GetChangeHistory = GetChangeHistory;
    

    function GetChangeLogById(id, objectType) {
        return ApiService.get('/api/changeLogAPI/GetChangeHistory?id=' + id + "&objectype=" + objectType).then(handleSuccess, handleError('Error getting change log by id'));
    }

    function GetChangeHistory(objectId, lang, objectType) {
        var request = ApiService.post("/api/ChangeLogApi/GetChangeHistory?objectid=" + objectId + "&objectype=" + objectType + "&lang=" + lang);
        return request;
    }

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }


    return self;
}